// extracted by mini-css-extract-plugin
module.exports = {"container":"Action_container__U6FZw","icon":"Action_icon__DOZLR","text":"Action_text__TQt9E"};